import brandConfig, { constants } from '@ourbranch/brand-config';

import brandLogo from 'staff-brand-icons/logo.svg';
import brandOpaqueBackgroundLogo from 'staff-brand-icons/opaque-background-logo.svg';
import appConfig from 'staff-app-config';

const isBranchEnv = import.meta.env.VITE_BRAND_NAME?.toLowerCase() === 'branch';

export { brandConfig, constants as brandConstants, brandLogo, brandOpaqueBackgroundLogo, isBranchEnv, appConfig };
